const $ = window.jQuery;

/**
 * Allow for block specific JS logic
 */
class Block
{

    /**
     * Setup class and trigger events
     *
     * @param {String} id Block ID (e.g. `her001`)
     */
    constructor(id)
    {

        if (!id) {
            console.error('id is required');
            return;
        }

        this.id = id;        // block ID (e.g. `her001`)
        this.el = undefined; // container element

        // every block triggers a `block-init` function on init and block editor
        // change
        $(window).on('block-init', (e) => {

            const {id, el} = e.detail;     // retrieve data from event

            if (this.id !== id) {
                return;
            }    // check event is for requested block

            this.el = el;

            this.init($(this.el));           // call overridable init function

        });

    }

    /**
     * Override this function to call block specific JS
     *
     * @param {jQuery el} $el Container element of block
     */
    function($el)
    {
    }

}

export default Block;
